// Avatar Customization with Real-time Preview
(function () {
    'use strict';

    const BASE_URL = 'https://api.dicebear.com/9.x/dylan/svg';
    const avatarPreview = document.getElementById('avatarPreview');
    const form = document.getElementById('avatarForm');

    function updatePreview() {
        const params = new URLSearchParams();
        params.append('size', '300');

        // Seed
        const seed = document.querySelector('input[name="Seed"]');
        params.append('seed', seed.value);

        // Background Color
        const backgroundColor = document.querySelector('input[name="BackgroundColor"]:checked');
        if (backgroundColor) {
            params.append('backgroundColor', backgroundColor.value);
        }

        // Facial Hair
        const facialHair = Array.from(document.querySelectorAll('input[name="FacialHairProbability"]:checked'))
            .map(input => input.value);
        if (facialHair.length > 0) {
            params.append('facialHairProbability', facialHair.join(','));
        }

        // Hair
        const hair = Array.from(document.querySelectorAll('input[name="Hair"]:checked'))
            .map(input => input.value);
        if (hair.length > 0) {
            params.append('hair', hair.join(','));
        }

        // Hair Color
        const hairColor = Array.from(document.querySelectorAll('input[name="HairColor"]:checked'))
            .map(input => input.value);
        if (hairColor.length > 0) {
            params.append('hairColor', hairColor.join(','));
        }

        // Mood
        const mood = Array.from(document.querySelectorAll('input[name="Mood"]:checked'))
            .map(input => input.value);
        if (mood.length > 0) {
            params.append('mood', mood.join(','));
        }

        // Skin Color
        const skinColor = Array.from(document.querySelectorAll('input[name="SkinColor"]:checked'))
            .map(input => input.value);
        if (skinColor.length > 0) {
            params.append('skinColor', skinColor.join(','));
        }

        avatarPreview.src = `${BASE_URL}?${params.toString()}`;
    }

    if (form && avatarPreview) {

        // Add event listeners to all inputs
        const allInputs = form.querySelectorAll('input[type="radio"], input[type="checkbox"]');
        allInputs.forEach(input => {
            input.addEventListener('change', updatePreview);
        });

        // Update preview with defaults
        updatePreview();
    }

})();
